import addElement from '../helpers/addElement';
import FilterController from '../../controllers/filter';

class Filter {
  constructor() {
    this.instance = null;
  }

  init(instance) {
    this.instance = instance;
    this.instance.addTaskLayer({
      renderer: {
        render: task => this.renderFilterTasks(task),
        getVisibleRange: this.instance.getVisibleTasksRange,
      },
      filter(task) {
        const foundTasks = FilterController.foundTasksMap;

        if (foundTasks.length === 0) {
          return false;
        }

        let visible = task.type === 'task' && !!foundTasks[task.id];
        const links = [];

        task.$source.forEach(linkId => {
          links.push(instance.getLink(linkId));
        });
        task.$target.forEach(linkId => {
          links.push(instance.getLink(linkId));
        });

        const hasConnections = links.some(link => !foundTasks[link.target] || !foundTasks[link.source]);

        if (Number.isNaN(+task.parent) || task.parent === 0) {
          visible = true;
        }

        return visible && hasConnections;
      },
    });
  }

  renderFilterTasks(task) {
    const sizes = this.instance.getTaskPosition(task, task.start_date, task.end_date);
    const taskPosition = this.instance.getTaskPosition(task);
    const taskWidth = taskPosition.width;
    const wrapper = document.createElement('div');
    const links = this.instance.getLinks();
    const connections = _.filter(links, link => (link && (link.target === task.id || link.source === task.id)));
    let leftConnection = false;
    let rightConnection = false;

    connections.forEach(link => {
      if (link.source === task.id) {
        if (link.type === this.instance.config.links.finish_to_start || link.type === this.instance.config.links.finish_to_finish) {
          rightConnection = true;
        } else if (link.type === this.instance.config.links.start_to_finish || link.type === this.instance.config.links.start_to_start) {
          leftConnection = true;
        }
      } else if (link.target === task.id) {
        if (link.type === this.instance.config.links.finish_to_start || link.type === this.instance.config.links.start_to_start) {
          leftConnection = true;
        } else if (link.type === this.instance.config.links.finish_to_finish || link.type === this.instance.config.links.start_to_finish) {
          rightConnection = true;
        }
      }
    });

    if (rightConnection) {
      addElement({
        css: 'filter-link filter-link-right',
        left: `${taskPosition.left + taskWidth}px`,
        top: `${sizes.top + sizes.height / 2}px`,
        html: '',
        wrapper,
      });
    }

    if (leftConnection) {
      addElement({
        css: 'filter-link filter-link-left',
        left: `${taskPosition.left - 20}px`,
        top: `${sizes.top + sizes.height / 2}px`,
        html: '',
        wrapper,
      });
    }

    return wrapper;
  }
}

export default new Filter();
